import React, { useEffect } from "react";
import { Box, Center, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";

const RADIUS = 24;
const DOT_SIZE = 10;
const DOT_COLORS = [
  "#DADADA",
  "#A7A7A7",
  "#818181",
  "#4B4B4B",
  "#CACACA",
  "#DADADA",
  "#DADADA",
  "#DADADA",
];
const N = DOT_COLORS.length;

const getDotColorCycle = (i) => {
  const frames = [];
  for (let step = 0; step <= N; step++) {
    frames.push(DOT_COLORS[(i - step + N) % N]);
  }
  return frames;
};

export default function Loading() {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100vh"
      bg="rgba(15, 15, 15, 0.64)"
      zIndex="1000"
    >
      <Center height="100%" flexDir="column" gap={4}>
        <Box position="relative" w="60px" h="60px">
          {DOT_COLORS.map((_, i) => (
            <motion.div
              key={i}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: `${DOT_SIZE}px`,
                height: `${DOT_SIZE}px`,
                marginTop: `-${DOT_SIZE / 2}px`,
                marginLeft: `-${DOT_SIZE / 2}px`,
                borderRadius: "50%",
                transform: `rotate(${i * (360 / N)}deg) translate(0, -${RADIUS}px)`,
              }}
              animate={{ backgroundColor: getDotColorCycle(i) }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            />
          ))}
        </Box>
        <Text textStyle="body.regular" color="textBlack.400">
          Բեռնում է
        </Text>
      </Center>
    </Box>
  );
}
